import type { FC } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Text } from "../Text";
import { Icon } from "../Icon";
import type { IconProp } from "../../props";

import { containerStyle } from "./UserPrompt.css";

export type UserPromptProps = IconProp & {
  children: string;
};

/**
 * A user message component that displays a message with an icon.
 */
export const UserPrompt: FC<UserPromptProps> = ({
  icon = "transcribe",
  children,
}) => {
  const message = children.trim().replace(/\n/g, "");

  return (
    <div className={mergeClasses(containerStyle)}>
      <Icon icon={icon} size="s" />
      <Text clamp={3}>{message}</Text>
    </div>
  );
};
